import React from "react";
import CategoryEdit from "../../../components/admin/categories/category-edit";
import AdminTemplate from "../../../templates/admin-template";

const AdminCategoryEditPage = () => {
  return (
    <AdminTemplate>
      <CategoryEdit />
    </AdminTemplate>
  );
};

export default AdminCategoryEditPage;
